/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Pill_IdleInputs */



/**
* | output |
* | --- |
* | "In person" |
*
* @param {Meeting_Offline_Pill_IdleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_pill_idle = /** @type {((inputs?: Meeting_Offline_Pill_IdleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Pill_IdleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Fysiek gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("En présentiel")
	return /** @type {LocalizedString} */ ("In person")
});